
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/website/sitemap",
      function () {
        return require("private-next-pages/website/sitemap.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/website/sitemap"])
      });
    }
  